var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4224 4C18.8939 4 19.3461 4.1873 19.6795 4.5207C20.0129 4.8541 20.2002 5.30628 20.2002 5.77778V18.2222C20.2002 18.6937 20.0129 19.1459 19.6795 19.4793C19.3461 19.8127 18.8939 20 18.4224 20H5.97797C5.50648 20 5.05429 19.8127 4.72089 19.4793C4.3875 19.1459 4.2002 18.6937 4.2002 18.2222V5.77778C4.2002 5.30628 4.3875 4.8541 4.72089 4.5207C5.05429 4.1873 5.50648 4 5.97797 4H18.4224ZM17.978 17.7778V13.0667C17.978 12.2981 17.6727 11.5611 17.1292 11.0176C16.5858 10.4742 15.8487 10.1689 15.0802 10.1689C14.3246 10.1689 13.4446 10.6311 13.018 11.3244V10.3378H10.538V17.7778H13.018V13.3956C13.018 12.7111 13.5691 12.1511 14.2535 12.1511C14.5836 12.1511 14.9001 12.2822 15.1335 12.5156C15.3669 12.749 15.498 13.0655 15.498 13.3956V17.7778H17.978ZM7.64908 8.94222C8.04514 8.94222 8.42498 8.78489 8.70503 8.50484C8.98509 8.22478 9.14242 7.84495 9.14242 7.44889C9.14242 6.62222 8.47575 5.94667 7.64908 5.94667C7.25067 5.94667 6.86857 6.10494 6.58685 6.38666C6.30513 6.66838 6.14686 7.05047 6.14686 7.44889C6.14686 8.27556 6.82242 8.94222 7.64908 8.94222ZM8.88464 17.7778V10.3378H6.42242V17.7778H8.88464Z",
    fill: "#9BA9B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon2);
export default __webpack_public_path__ + "static/media/linkedinIcon2.d48006c62941c961ac7820114d319c40.svg";
export { ForwardRef as ReactComponent };